import { loadWidget } from '@sitevision/react';
import React from 'react';
import ReactDOM from 'react-dom';
import SavingPlanOverviewSection from './templates/molecules/saving-plan-overview-section';

loadWidget('.plf-saving-plan-overview-area', savingPlanOverviewWidget => {
    const action = savingPlanOverviewWidget.dataset.action;
    ReactDOM.render(<SavingPlanOverviewSection action={action} />, savingPlanOverviewWidget);
});
